import { ExternalMedia } from './external-media';
import { DiaryCategory } from './diary-category';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class CreateDiaryCommand {
  ScaffoldDiaryId: string;
  ScaffoldId: string;
  When: string;
  Notes: string;
  Media: ExternalMedia[];
  PercentageStanding: number;
  StandingTonnage: number;
  OwnerId: string;
  OffsetFromUtc: number;
  Category: DiaryCategory;
  CommandVersion: string;
  SourceApp: string;
  SourceAppVersion: string;
}


